import { render, staticRenderFns } from "./footerbar.vue?vue&type=template&id=0ae91a19&scoped=true&"
import script from "./footerbar.vue?vue&type=script&lang=js&"
export * from "./footerbar.vue?vue&type=script&lang=js&"
import style0 from "./footerbar.vue?vue&type=style&index=0&id=0ae91a19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae91a19",
  null
  
)

export default component.exports